import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  AllocationViewActionsInitialState,
  AllocationViewSetActionIdentifier,
  AllocationViewActionsCloseActionContainer,
  AllocationViewSetLeadUlis,
  AllocationViewActionsShouldUpdate,
} from './allocation-view-actions.actions';
import { AllocationViewSelectedEntityModel, AllocationViewLeadUliModel } from '../models';

export interface AllocationViewActionsStateModel {
  actionIdentifier: AllocationViewSelectedEntityModel;
  leadUlis: AllocationViewLeadUliModel[];
  closeActionContainer: boolean;
  shouldUpdate: boolean;
  loaded: boolean;
}

const initialState: AllocationViewActionsStateModel = {
  actionIdentifier: null,
  closeActionContainer: false,
  shouldUpdate: false,
  leadUlis: [],
  loaded: false,
};

@State<AllocationViewActionsStateModel>({
  name: 'allocationViewActions',
  defaults: initialState,
})
@Injectable()
export class AllocationViewActionsState {
  @Selector()
  static getActionIdentifier(state: AllocationViewActionsStateModel): AllocationViewSelectedEntityModel {
    return state.actionIdentifier;
  }

  @Selector()
  static getLoaded(state: AllocationViewActionsStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getCloseActionContainer(state: AllocationViewActionsStateModel): boolean {
    return state.closeActionContainer;
  }

  @Selector()
  static getShouldUpdate(state: AllocationViewActionsStateModel): boolean {
    return state.shouldUpdate;
  }

  @Selector()
  static getLeadUlis(state: AllocationViewActionsStateModel): AllocationViewLeadUliModel[] {
    return state.leadUlis;
  }

  @Action(AllocationViewSetLeadUlis)
  setLeadUlis(ctx: StateContext<AllocationViewActionsStateModel>, { payload }: AllocationViewSetLeadUlis): void {
    ctx.patchState({ leadUlis: payload });
  }

  @Action(AllocationViewSetActionIdentifier)
  setActionIdentifier(
    ctx: StateContext<AllocationViewActionsStateModel>,
    { payload }: AllocationViewSetActionIdentifier,
  ): void {
    ctx.patchState({ actionIdentifier: payload });
  }

  @Action(AllocationViewActionsCloseActionContainer)
  closeActionContainer(
    ctx: StateContext<AllocationViewActionsInitialState>,
    { payload }: AllocationViewActionsCloseActionContainer,
  ): void {
    ctx.patchState({
      closeActionContainer: payload,
    });
  }

  @Action(AllocationViewActionsShouldUpdate)
  shouldUpdate(
    ctx: StateContext<AllocationViewActionsInitialState>,
    { payload }: AllocationViewActionsShouldUpdate,
  ): void {
    ctx.patchState({
      shouldUpdate: payload,
    });
  }

  @Action(AllocationViewActionsInitialState)
  setInitialState(ctx: StateContext<AllocationViewActionsInitialState>): void {
    ctx.setState(initialState);
  }
}
